import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'have_there_been_cases_of_sexual_harassment'

export const dataPointDefinition = {
  retracedId: 'have_there_been_cases_of_sexual_harassment',
  name: 'Have there been cases of sexual harassment?',
  description:
    "Sexual harassment stems from unwelcome physical, verbal or non-verbal conduct of a sexual nature, including insults, inappropriate remarks, jokes, or comments on a person's dress, physique, age, or family situation; condescending or paternalistic attitudes with sexual implications that undermine dignity; unwelcome invitations, requests, sexual looks or gestures; and unnecessary physical contact such as touching, caresses, pinching or assault. Sexual harassment is unreasonable and offensive to the recipient, and may be directed against a person of the opposite or the same sex. Sexual harassment also can arise from conduct that creates an intimidating, hostile or humiliating working environment. \r\r\nInclude the numbers of male/ female victims, as well as any remedial actions taken in the finding.",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wt-dis-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 10690,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
